var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHullBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 58.3744L9.99999 40.0411L40 30.0411L70 40.0411L66.6667 58.3744M16.6667 37.8189V18.7078C16.6667 17.6032 17.5621 16.7078 18.6667 16.7078H61.3333C62.4379 16.7078 63.3333 17.6032 63.3333 18.7078V37.8189M33.3333 16.7078V7.70776C33.3333 7.15548 33.781 6.70776 34.3333 6.70776H45.6667C46.2189 6.70776 46.6667 7.15548 46.6667 7.70776V16.7078M6.66666 70.0411C9.99999 73.3744 20 73.3744 26.6667 66.7078C33.3333 73.3744 46.6667 73.3744 53.3333 66.7078C60 73.3744 70 73.3744 73.3333 70.0411",
    stroke: "#FFB800",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHullBody);
export default __webpack_public_path__ + "static/media/hull_body.ab150d0aebc7ad821944ce4a23cde581.svg";
export { ForwardRef as ReactComponent };